<template>
  <div class="home">
  </div>
</template>

<script>
export default {
  name: 'Home',
  mounted: function() {
	  this.$parent.close_mobile();
  }
}
</script>
